import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=a0610c24&scoped=true&"
import script from "./ModalFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ModalFeedback.vue?vue&type=style&index=0&id=a0610c24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0610c24",
  null
  
)

export default component.exports